import { DeleteOutlined } from '@ant-design/icons';
import { CSSProperties, FC, MouseEventHandler } from 'react';

export interface DeleteIconProps {
  className?: string;
  style?: CSSProperties;
  htmlColor?: string;
  titleAccess?: string;
  fontSize?: number | string;
  onClick?: MouseEventHandler<HTMLSpanElement>;
  'data-testid'?: string;
}

/** MUI SvgIcon / IconButton default in tables */
const DEFAULT_ICON_SIZE = 20;

function resolveFontSize(fontSize?: number | string) {
  if (typeof fontSize === 'number') {
    return fontSize;
  }

  if (typeof fontSize === 'string') {
    return fontSize;
  }

  return DEFAULT_ICON_SIZE;
}

export const DeleteIcon: FC<DeleteIconProps> = ({
  className,
  style,
  htmlColor = '#4F5863',
  titleAccess,
  fontSize,
  onClick,
  'data-testid': dataTestId,
}) => {
  return (
    <DeleteOutlined
      className={className}
      title={titleAccess}
      onClick={onClick}
      data-testid={dataTestId}
      style={{
        color: htmlColor === 'grey' ? '#4F5863' : htmlColor,
        fontSize: resolveFontSize(fontSize),
        ...style,
      }}
    />
  );
};
